<template>
	<div class="record-detail warehouse-detail">
		<section class="detail-hero">
			<div class="detail-hero-top">
				<div>
					<span class="detail-eyebrow">کالا · <span class="vn-mono">{{ detailData.identifier || '—' }}</span></span>
					<h2>{{ detailData.name_fa || 'جزئیات کالا' }}</h2>
					<p>{{ (detailData.type || {}).verbose_name || 'نوع کالا ثبت نشده' }}</p>
				</div>
				<router-link class="detail-back" :to="{ name: 'listWareHouse' }">بازگشت به فهرست <span aria-hidden="true">←</span></router-link>
			</div>
			<div class="stock-tiles">
				<div class="stock-tile t-total"><span>موجودی کل پروژه</span><b class="vn-num">{{ number(total) }}</b></div>
				<div class="stock-tile t-loc"><span>موجودی در انبارها</span><b class="vn-num">{{ number(detailData.locations_stock_count) }}</b></div>
				<div class="stock-tile t-user"><span>موجودی نزد افراد</span><b class="vn-num">{{ number(detailData.users_stock_count) }}</b></div>
			</div>
		</section>

		<section class="box list-box">
			<nav class="stock-tabs" aria-label="نمای موجودی">
				<button type="button" :class="{ current: tab === 'location' }" :aria-pressed="tab === 'location'" @click="switchTab('location')">موجودی انبارها</button>
				<button type="button" :class="{ current: tab === 'user' }" :aria-pressed="tab === 'user'" @click="switchTab('user')">موجودی نزد افراد</button>
			</nav>
			<Tableview hover bordered :showNoContent="loading" :showNoData="!loading && rows.length === 0" :errorMessage="error" @retry="load">
				<template #TableTitle>
					<tr>
						<th>ردیف</th>
						<th>{{ tab === 'location' ? 'انبار' : 'نیروی اجرایی' }}</th>
						<th>موجودی</th>
						<th class="actions-column">عملیات</th>
					</tr>
				</template>
				<template #TableBody>
					<tr v-for="(item, index) in rows" :key="item.id">
						<td class="persian-number">{{ index + 1 }}</td>
						<td class="cell-primary">{{ tab === 'location' ? (item.location || {}).name_fa : person(item.user) }}</td>
						<td class="persian-number">{{ number(item.stock_count) }}</td>
						<td class="actions-cell">
							<RowActions :items="[
								{ label: 'افزایش موجودی', icon: 'plus', action: () => openModal('stock', item), hidden: tab !== 'location' },
								{ label: 'ثبت مصرف', icon: 'minus', action: () => openModal('use', item) },
								{ label: 'انتقال به انبار', icon: 'transfer', action: () => openModal('relocate', item) },
								{ label: 'تحویل به نیروی اجرایی', icon: 'user', action: () => openModal('deliver', item) },
							]" />
						</td>
					</tr>
				</template>
			</Tableview>
		</section>

		<b-modal :visible="!!modal" :title="modalTitle" hide-footer centered header-close-label="بستن" @hidden="closeModal">
			<form @submit.prevent="submit">
				<p class="detail-muted">
					{{ tab === 'location' ? 'انبار مبدأ' : 'نیروی مبدأ' }}:
					<strong>{{ tab === 'location' ? (columnData.location || {}).name_fa : person(columnData.user) }}</strong>
					· موجودی <strong class="vn-num">{{ number(columnData.stock_count) }}</strong>
				</p>
				<label for="ware-amount">مقدار</label>
				<input id="ware-amount" v-model="amount" class="inputs" type="number" min="1" :max="modal === 'stock' ? null : columnData.stock_count" required />
				<p v-if="overStock" class="detail-error" role="alert">مقدار بیشتر از موجودی مبدأ است.</p>
				<template v-if="modal === 'relocate'">
					<label for="ware-location" class="mt-3">انبار مقصد</label>
					<select id="ware-location" v-model="pickLocation" class="form-select" required>
						<option value="" disabled>انتخاب کنید</option>
						<option v-for="location in locationLists" :key="location.id" :value="location.id">{{ location.name_fa }}</option>
					</select>
				</template>
				<template v-if="modal === 'deliver'">
					<label for="ware-promoter" class="mt-3">نیروی اجرایی</label>
					<select id="ware-promoter" v-model="pickPromoter" class="form-select" required>
						<option value="" disabled>انتخاب کنید</option>
						<option v-for="promoter in promoterLists" :key="promoter.id" :value="promoter.user.id">{{ person(promoter.user) }}</option>
					</select>
				</template>
				<template v-if="modal !== 'stock'">
					<label for="ware-note" class="mt-3">توضیحات</label>
					<textarea id="ware-note" v-model="note" rows="3" placeholder="اختیاری"></textarea>
				</template>
				<div class="detail-form-actions mt-3">
					<button type="button" class="remove-filtes" @click="closeModal">انصراف</button>
					<button type="submit" class="accept" :disabled="!canSubmit">{{ busy ? 'در حال ثبت…' : 'ثبت' }}</button>
				</div>
			</form>
		</b-modal>
	</div>
</template>
<script>
import Tableview from '@/components/Tableview/index.vue';
import RowActions from '@/components/RowActions/index.vue';

const TITLES = { stock: 'افزایش موجودی انبار', use: 'ثبت مصرف', relocate: 'انتقال به انبار', deliver: 'تحویل به نیروی اجرایی' };

export default {
	components: { Tableview, RowActions },
	data() {
		return {
			tab: 'location',
			detailData: {},
			locationRows: [],
			userRows: [],
			loading: true,
			error: '',
			promoterLists: [],
			locationLists: [],
			modal: '',
			columnData: {},
			amount: null,
			pickPromoter: '',
			pickLocation: '',
			note: '',
			busy: false,
		};
	},
	computed: {
		wareId() { return this.$route.params.id; },
		project() { return this.$STORE.state.userConfig.setProjectId; },
		total() { return Number(this.detailData.locations_stock_count || 0) + Number(this.detailData.users_stock_count || 0); },
		rows() { return this.tab === 'location' ? this.locationRows : this.userRows; },
		modalTitle() { return TITLES[this.modal] || ''; },
		overStock() { return this.modal !== 'stock' && Number(this.amount) > Number(this.columnData.stock_count || 0); },
		canSubmit() {
			if (this.busy || !(Number(this.amount) > 0) || this.overStock) return false;
			if (this.modal === 'relocate') return !!this.pickLocation;
			if (this.modal === 'deliver') return !!this.pickPromoter;
			return true;
		},
	},
	mounted() { this.load(); },
	methods: {
		number(value) { return Number(value || 0).toLocaleString('fa-IR'); },
		person(user) { return user ? [user.first_name, user.last_name].filter(Boolean).join(' ') : '—'; },
		switchTab(tab) {
			if (this.tab === tab) return;
			this.tab = tab;
			this.load();
		},
		async load() {
			this.loading = true;
			this.error = '';
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.WAREHOUSE_USER_LOCATION_RETRIEVE + this.wareId + '/?p=' + this.project + '&limit=20&offset=0&based_on=' + this.tab,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				this.detailData = res.data;
				if (this.tab === 'location') this.locationRows = res.data.locations || [];
				else this.userRows = res.data.users || [];
			} else this.error = this.$ApiServiceLayer.getErrorMessage(res);
			this.loading = false;
		},
		openModal(kind, row) {
			Object.assign(this, { modal: kind, columnData: row, amount: null, pickLocation: '', pickPromoter: '', note: '' });
			if (kind === 'relocate') this.getLocationLists();
			if (kind === 'deliver') this.getPromoterLists();
		},
		closeModal() { this.modal = ''; },
		// A transaction moves stock from the row (FROM line) to a destination (TO line);
		// consumption has no destination, stock-in has no source.
		async submit() {
			if (!this.canSubmit) return;
			const amount = parseInt(this.amount, 10);
			const source = this.tab === 'location' ? 'LOCATION' : 'USER';
			const to = { stock: 'LOCATION', relocate: 'LOCATION', deliver: 'USER', use: null }[this.modal];
			const data = {
				lines: [
					{
						ware: this.wareId,
						amount: -amount,
						location: this.modal === 'stock' ? null : source === 'LOCATION' ? this.columnData.location.id : null,
						user: this.modal === 'stock' ? null : source === 'USER' ? this.columnData.user.id : null,
						side: 'FROM',
						involved: this.modal === 'stock' ? null : source,
					},
					{
						ware: this.wareId,
						amount,
						location: this.modal === 'stock' ? this.columnData.location.id : to === 'LOCATION' ? this.pickLocation : null,
						user: to === 'USER' ? this.pickPromoter : null,
						side: 'TO',
						involved: to,
					},
				],
				description: this.note || null,
			};
			this.busy = true;
			try {
				const res = await this.$ApiServiceLayer.post(this.$PATH.RELATIVE_PATH.POST.WARE_TRANSACTION + '?p=' + this.project, this.$PATH.SERVICE_NAME.EMPTY, data);
				if (res.status === 200 || res.status === 201) {
					this.modal = '';
					this.$notify({ group: 'tc', type: 'success', text: 'گردش موجودی ثبت شد.' });
					this.load();
				} else this.$notify({ group: 'tc', type: 'error', text: this.$ApiServiceLayer.getErrorMessage(res) });
			} finally {
				this.busy = false;
			}
		},
		async getPromoterLists() {
			const res = await this.$ApiServiceLayer.get(this.$PATH.RELATIVE_PATH.GET.GET_PROMOTER_LIST + '?p=' + this.project, this.$PATH.SERVICE_NAME.AUTH);
			if (res.status === 200) this.promoterLists = res.data;
		},
		async getLocationLists() {
			const res = await this.$ApiServiceLayer.get(this.$PATH.RELATIVE_PATH.MULTI.LOCATION_LIST_CREATE + '?p=' + this.project, this.$PATH.SERVICE_NAME.EMPTY);
			if (res.status === 200) this.locationLists = res.data;
		},
	},
};
</script>
<style scoped>
.stock-tiles { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; margin-top: 18px; }
.stock-tile { position: relative; display: grid; gap: 2px; padding: 14px 16px; background: var(--surface); border: 1px solid var(--paper-300); border-radius: var(--r-sm); overflow: hidden; }
.stock-tile span { font-size: 12px; color: var(--text-3); font-weight: 700; }
.stock-tile b { font-size: 26px; font-weight: 950; line-height: 1.4; }
.stock-tile::after { content: ''; position: absolute; inset-inline-start: 0; bottom: 0; width: 52px; height: 4px; transform: skewX(var(--slant)); transform-origin: left; }
.t-total::after { background: var(--amber-500); } .t-loc::after { background: var(--teal-500); } .t-user::after { background: var(--pink-500); }
.stock-tabs { display: flex; gap: 2px; padding: 0 16px; border-bottom: 1px solid var(--line); }
.stock-tabs button { position: relative; min-height: 48px; padding: 0 16px; border: 0; background: none; color: var(--text-3); font-weight: 700; font-size: 13px; }
.stock-tabs button.current { color: var(--text); }
.stock-tabs button.current::after { content: ''; position: absolute; inset-inline: 12px; bottom: -1px; height: 3px; background: var(--pink-500); transform: skewX(var(--slant)); }
.warehouse-detail .table-view { margin-top: 0; border: 0; border-radius: 0; }
@media (max-width: 767px) { .stock-tiles { grid-template-columns: 1fr; } }
</style>
